




























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  AttachSettingData, AttachSettingItemData, emptyData, emptyItem,
  getNew, getInfo, putData, postData
} from '@/api/systemManage/attachSetting'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import { DDLItem, DefDDLItem, getProjectPhase } from '@/api/common/select'
import { enFirstType, enLookupType, enAttachSetType } from '@/configs/enums'
import { copyArray, arrayReorder, splitToList } from '@/configs/functions'
import Element from 'element-ui'
import PageForm from '@/components/pageLayout/form.vue'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

@Component({
  components: {
    PageForm
  }
})
export default class AttachSetting extends Vue {
  public collapseNames: string[] = ['base']
  public step: number = 1
  get showNextStep(): boolean {
    const f = this.form
    if (f.AttachType > 0) {
      if (this.projectTyps.indexOf(f.AttachType) > -1) {
        return f.Flag1Id > 0 //&& f.Flag2Id > 0
      }
      return true
    }
    return false
  }

  public form: AttachSettingData = Object.assign({}, emptyData)
  public loading = false
  public firstType: number = enFirstType.Select
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public typeList: DDLItem[] = [this.defItem]
  public flag1List: DDLItem[] = [this.defItem]
  public flag2List: DDLItem[] = [this.defItem]
  //项目相关附件
  public projectTyps: number[] = [
    enAttachSetType.Project,
    enAttachSetType.Ratify,
    enAttachSetType.Record,
    enAttachSetType.Approval
  ]
  public extList: string[] = [
    'Zip', 'Rar', 'Doc', 'Docx', 'Xls', 'Xlsx', 'Cad', 'Pdf', 'Jpg', 'Jpeg', 'Bmp', 'Png', 'Gif'
  ]
  // dynamic component
  public $refs!: {
    formCtrl: PageForm
  }
  public created() {
    this.fetchSource()
  }
  public mounted() {
    this.fetchData()
  }
  @DataSourceModule.Getter('unitClassify')
  public unitClassify!: any
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.typeList = data.typeList
    }
  }
  public typeChange(reset: number) {
    var f = this.form
    this.flag1List = [this.defItem]
    this.flag2List = [this.defItem]
    if (reset === 1) {
      f.Flag1Id = 0
      f.Flag2Id = 0
    }
    if (this.projectTyps.indexOf(f.AttachType) > -1) {
      getProjectPhase(this.firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.flag1List = data
        }
      })
      var unitClassify = copyArray(this.unitClassify)
      if (unitClassify) {
        this.flag2List = unitClassify
      }
    }
    else {
      // 其他类型的附件在这里设置关联数据
    }
  }
  public nextStep() {
    const f = this.form
    getNew(f.AttachType, f.Flag1Id, f.Flag2Id).then((response: { data: any }) => {
      this.form = response.data
      this.loading = false
      this.step = 2
    })
  }
  public prevStep() {
    this.step = 1
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchForm(id)
  }
  public fetchForm(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      this.form = response.data
      this.loading = false
      if (this.form.Id == 0) {
        this.step = 1
      } else {
        this.step = 2
        // if (this.form.ItemList.length > 0) {
        //     this.form.ItemList.forEach((e: AttachSettingItemData, i: number) => {
        //         e.ArrExts = splitToList(e.Exts, '.')
        //     })
        // }
        this.typeChange(0)
      }
    })
  }
  public addItem() {
    const item = Object.assign({}, emptyItem)
    this.form.ItemList.push(item)
  }
  public delItem(index: number) {
    this.$confirm(`确定要删除该项吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.form.ItemList.splice(index, 1)
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
  public moveUp(index: number) {
    const list = this.form.ItemList
    arrayReorder(list, index, true)
  }
  public moveDown(index: number) {
    const list = this.form.ItemList
    arrayReorder(list, index, false)
  }
  public onCancel() {
    this.$router.push({ path: '/AttachSetting' })
  }
  public onSubmit() {
    let f = this.form
    if (f.ItemList.length > 0) {
      f.ItemList.forEach((e: AttachSettingItemData, i: number) => {
        e.Exts = ''
        if (e.ArrExts.length > 0) {
          e.Exts = '.' + e.ArrExts.join('.')
        }
      })
    }
    const promist = this.form.Id > 0 ? putData(this.form.Id, this.form) : postData(this.form)
    promist.then((response: { data: any }) => {
      const data = response.data
      const msg = this.form.Id > 0 ? '保存' : '创建'
      if (data && !data.IsError) {
        this.$message({
          message: `${msg}成功`,
          type: 'success'
        })
        this.$router.push({ path: '/AttachSetting' })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`,
          type: 'success'
        })
        console.log('提交失败', data)
      }
    }, (data: any) => {
      console.log(data);
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
